
<ng-container *ngIf="{row: columnData | async} as $">

  <div *ngIf="$.row && $.row.is_ewallet_deposit && $.row.is_ewallet_deposit == true; else prefix" class="flex align-items-center">
    <i class="fa fa-wallet mr-2"></i>  {{'INVOICE.COLUMNS.E_WALLET' | translate}}
  </div>
  <ng-template #prefix>
    <div *ngIf="$.row.invoiceNumbers && $.row.invoiceNumbers.length > 0; else showprefix">
      <ng-container *ngFor="let invoice of $.row.invoiceNumbers">
        <a class="text-primary" href="javascript:void(0)" (click)="OpenInvoiceDetails(invoice)" >{{invoice}}</a> 
      </ng-container> 
    </div>
    <ng-template #showprefix>
      <span>{{$.row.inv_number_prefix}}</span> 
    </ng-template>
  </ng-template>
</ng-container>


